import { render } from "./HeaderStreekfondsoostvlaanderen.vue?vue&type=template&id=2b603adc&scoped=true"
import script from "./HeaderStreekfondsoostvlaanderen.vue?vue&type=script&lang=js"
export * from "./HeaderStreekfondsoostvlaanderen.vue?vue&type=script&lang=js"

import "./HeaderStreekfondsoostvlaanderen.vue?vue&type=style&index=0&id=2b603adc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b603adc"]])

export default __exports__